import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import MarketingLeoDemoChat from "../components/home/MarketingLeoDemoChat";
import { AuthContext } from "../context/AuthProvider";
import { trackPageView } from "../helpers/dashboardAnalytics";
import { device } from "../lib/breakpoints";

const INTRO_GREETING =
  "Hi - I'm Clumse AI. Tell me what's going on (symptoms, which unit or system, and anything you've already tried). We'll clarify the job here first; when you're ready, you can move to Contractor Bids to review vendor outreach.";

export default function WhatsWrongPage() {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    trackPageView("/whats-wrong", "Whats wrong - Clumse AI triage");
  }, []);

  return (
    <PageWrap>
      <PageHeader
        title="What's wrong?"
        subtitle="Chat with Clumse AI before we search for vendors. No commitment until you invite bids on a job."
      />
      <ActionsRow>
        <StyledLink to="/bids">Contractor bids</StyledLink>
        <StyledLink to="/chat">Chat with Clumse</StyledLink>
      </ActionsRow>
      <ChatCard>
        <MarketingLeoDemoChat
          showDemoCaption={false}
          propertyLabel={
            user?.email ? `your account (${user.email})` : "your account"
          }
          greetingText={INTRO_GREETING}
        />
      </ChatCard>
      <FootNote>
        This chat uses the same Clumse AI demo engine as the marketing site. For
        account and subscription details, open{" "}
        <Link to="/profile">Profile</Link>.
      </FootNote>
    </PageWrap>
  );
}

const PageWrap = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 1.5rem clamp(1rem, 3vw, 2rem) 3rem;
  box-sizing: border-box;

  @media ${device.mobile} {
    padding-bottom: 2rem;
  }
`;

const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin: 0.75rem 0 1.25rem;
`;

const StyledLink = styled(Link)`
  font-family: var(--font-secondary, "Inter", system-ui, sans-serif);
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--color-primary, #2c5f2d);
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: var(--color-primary-dark, #1e4620);
  }
`;

const ChatCard = styled.div`
  margin-top: 0.5rem;
  border-radius: 16px;
  border: 1px solid var(--color-border-light, #e2e8f0);
  background: var(--color-bg-secondary, #fff);
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
`;

const FootNote = styled.p`
  margin-top: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--color-text-light, #64748b);
  font-family: var(--font-secondary, "Inter", system-ui, sans-serif);
  max-width: 52rem;

  a {
    color: var(--color-primary, #2c5f2d);
    font-weight: 600;
  }
`;
